import React from 'react'
import {
  TextField,
  TextInput,
} from 'react-admin'
import { Datagrid, List, Filter } from '../../custom'
import { useLabel } from '../../../hooks'

const HourlyWorkTypesFilter = props => {
  const label = useLabel(props)

  return (
    <Filter>
      <TextInput label={label('name', 'filter')} source='name_i_cont' />
    </Filter>
  )
}

const HourlyWorkTypesList = props => {
  const label = useLabel(props)

  return (
    <List
      {...props}
      filters={<HourlyWorkTypesFilter />}
    >
      <Datagrid>
        <TextField source='name' label={label('name')} />
      </Datagrid>
    </List>
  )
}

export default HourlyWorkTypesList
